export default __webpack_public_path__ + "static/media/asset03.265feea8.png";